import React, { Fragment, useState } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

import {  Card, CardBody, Row, Col, Nav, NavLink, NavItem, TabContent, TabPane, Container } from 'reactstrap';
import ProductCard from './components/ProfileCard';
import RelatedBuildings from './components/RelatedBuildings';
import ProfileTabs from './components/ProfileTabs';
import BuildingAmenities from './components/BuildingAmenities';

import BuildingManagement from './components/BuildingManagement';
import BuildingDetails from './components/BuildingDetails';

import CommercialPercent from './components/CommercialPercent';

import OfferingHistory from './components/OfferingHistory';

import LendingHistory from './components/LendingHistory';

import ShowMap from './../../../../shared/components/map';
import BuildingPeopleCompanies from './components/BuildingPeopleCompanies';
import BuildingEnergy from './components/BuildingEnergy';
import LatestStatus from './components/LatestStatus';
import LatestActivities from './components/LatestActivities';


import BuildingProfile from './components/BuildingProfile';
import { Publisher } from '../../../../shared/pubsub/publisher.js';

import HouseProfile from './../HouseProfile';
import BuildingDetailsCard from './../HouseProfile/components/BuildingDetailsCard';
import ProfileGallery from './components/ProfileGallery';
import LinearLoading from '../../../../shared/components/LinearLoading';
import InTheArea from './components/InTheArea';

import classnames from 'classnames';

import{
	_capitalizeText,
	_formatNumber,
	_slugifyText,
	_getBuildingURL,
	_isCCC,
	_isHouse,
	_getMPNDBuildingPopupURL,
	_getBuildingPhotos,
	_shouldShow,
	_getFirstAndLastFromFullName,
	_getFeaturesArr,
} from '../../../../shared/helpers/utils';

import { _hasPermission } from '../../../../shared/helpers/access';
import EnterpriseGate from '../../../../shared/components/payment/EnterpriseGate';
import SkipTraceUnifiedModal from '../../../../shared/components/skiptrace/SkipTraceUnifiedModal';

import { _parseCoordinates } from '../../../../shared/helpers/mapUtil';
import GStreetMap from '../../../../shared/components/map/GStreetMap.jsx';
import SalesMapBox from '../../../../shared/components/map/SalesMapBox';
import MapModal from '../../../../shared/components/map/MapModal';
import { amenitiesList } from '../../../../shared/helpers/bp-utils';

const ShowAmenities = (props) => {
	const { bldgArea, unitSize, buildingRes } = props;
	const compiledFeatureList = buildingRes ? _getFeaturesArr('building', false, buildingRes) : [];
	const highlightedAmenities = amenitiesList.filter(item => compiledFeatureList.some(el => item.values.includes(el)));
	const buildingAmenitiesFiltered = compiledFeatureList.filter(item => !amenitiesList.some(el => el.values.includes(item)));
	const otherAmenities = buildingRes && _shouldShow(buildingRes.amenities_other) && Array.isArray(buildingRes.amenities_other)
		? buildingRes.amenities_other : [];
	const featuresLen = buildingAmenitiesFiltered.length + otherAmenities.length;
	const hasAmenities = featuresLen > 1 || highlightedAmenities.length > 1 || (featuresLen + highlightedAmenities.length > 1);
	if (!hasAmenities) return null;
	return (
		<Fragment>
		{bldgArea.totalArea > 0 && unitSize > 300 ?
			<Row>
				<Col md={8}>
					<h3 className="section-title section-title--not-last">Amenities & Features</h3>
					<h3 className="section-title section-title--not-last subhead"> </h3>
					<hr/>
					<BuildingAmenities {...props} small />
				</Col>
				<Col md={4}>
					<h3 className="section-title section-title--not-last">&nbsp;</h3>
					<h3 className="section-title section-title--not-last subhead"> </h3>
					<CommercialPercent {...props} bldgArea={bldgArea} />
				</Col>
			</Row>
		:
			<Row>
				<Col md={12}>
					<h3 className="section-title section-title--not-last">Amenities & Features</h3>
					<h3 className="section-title section-title--not-last subhead"> </h3>
					<hr/>
					<BuildingAmenities {...props} />
				</Col>
			</Row>

		}
		</Fragment>
	)

}

const Profile = (props) => {

	const { buildingRes, unitQuery } = props;
	const [activeTab, setActiveTab] = useState(props.match && props.match.params.subtab ? props.match.params.subtab :  "summary");
	const [streetView, setStreetView] = useState(false);
	const [standardView, setStandardView] = useState(false);

	const _handleStreetView = (event) => {
		event.preventDefault();
		setStreetView(!streetView);
	};

	const toggleView = (event) => {
		event.preventDefault();
		event.stopPropagation();
		setStandardView(!standardView);
	};

	const _selectedBuildingClick = (building) => {
		const buildingURL = _getMPNDBuildingPopupURL(building, "key");
		window.open(buildingURL);
	};

	const handleBuildingClick = (event, building) => {
		const buildingURL = _getBuildingURL(building, "id");
		window.open(buildingURL);
	};
	const _toggleTab = (tab) => {
		if (activeTab !== tab) {
		  const buildingURL = _getBuildingURL(buildingRes, 'building_slugs') + (tab ? `/tab/overview/${tab}` : '');
		  //props.history.replace(buildingURL);
		  window.history && window.history.pushState({}, null, buildingURL);
		  setActiveTab(tab)
		  Publisher.publish(`track.buildingOverview.${tab}`, {building: buildingRes.key});
		}
	  };
	const bldgArea = {
		totalArea : buildingRes && buildingRes.total_building_floor_area ? parseInt(buildingRes.total_building_floor_area.replace(/,/g, "")) : 0,
		totalAreaResi : buildingRes && buildingRes.residential_floor_area ? parseInt(buildingRes.residential_floor_area.replace(/,/g, "")) : 0,
		totalAreaRetail : buildingRes && buildingRes.retail_floor_area ? parseInt(buildingRes.retail_floor_area.replace(/,/g, "")) : 0,
		totalAreaComm : buildingRes && buildingRes.commercial_floor_area ? parseInt(buildingRes.commercial_floor_area.replace(/,/g, "")) : 0,
		totalAreaGarage : buildingRes && buildingRes.garage_floor_area ? parseInt(buildingRes.garage_floor_area.replace(/,/g, "")) : 0,
		totalAreaFactory : buildingRes && buildingRes.factory_floor_area ? parseInt(buildingRes.factory_floor_area.replace(/,/g, "")) : 0,
	}

	if(bldgArea.totalArea <=0 && buildingRes.pipeline_total_construction_floor_area && buildingRes.pipeline_total_construction_floor_area>1000){
		bldgArea.totalArea = buildingRes.pipeline_total_construction_floor_area;
	}

	if(bldgArea.totalArea < bldgArea.totalAreaResi || bldgArea.totalArea < bldgArea.totalAreaComm || bldgArea.totalArea < bldgArea.totalAreaRetail){
		bldgArea.totalArea = bldgArea.totalAreaResi + bldgArea.totalAreaRetail + bldgArea.totalAreaComm + bldgArea.totalAreaFactory;
	}
	bldgArea["totalCommercial"] =  bldgArea.totalAreaComm;
	if(bldgArea.totalAreaRetail > bldgArea.totalAreaComm){
		bldgArea["totalCommercial"] = bldgArea.totalAreaRetail;
	}

	bldgArea["totalOther"] =  bldgArea.totalArea - bldgArea["totalCommercial"];

	const totalArea = bldgArea.totalArea;
	const unitSize =  totalArea / buildingRes.inventory_total;
	let isHouse = _isHouse(buildingRes);
	if(isHouse && !props.unitsRes) return <LinearLoading />;

	const ownershipType = buildingRes.ownership_type ? buildingRes.ownership_type.toLowerCase() : '';
	const isCondoCoopCondop = _isCCC(buildingRes);
	const isRental = ['rental', 'rentals'].indexOf(ownershipType) >= 0;
	const isResidential = isCondoCoopCondop || isRental || isHouse || ownershipType.indexOf('multi') >= 0 || ownershipType.indexOf('single') >= 0 || ownershipType.indexOf('family') >= 0;
	const isSkipTraceable = isCondoCoopCondop || isHouse || ownershipType.indexOf('multi') >= 0 || ownershipType.indexOf('single') >= 0 || ownershipType.indexOf('family') >= 0;

	const renderSummaryContent = () => {
		// House view
		if (isHouse && props.unitsRes && props.unitsRes[0]) {
			return <HouseProfile {...props} property={props.unitsRes[0]} />;
		}

		// Condo/Coop/Condop view
		if (isCondoCoopCondop) {
			return (
				<Fragment>
					<Row>
						<ProductCard {...props} />
					</Row>

					{['sponsor', 'resale'].indexOf(buildingRes.building_status)>=0 &&
						<Fragment>
							{unitQuery &&
								<LatestActivities {...props} />
							}
							<BuildingPeopleCompanies {...props} />

							<BuildingManagement {...props} />
						</Fragment>
					}

					<Row>
						<Col md={8}>
						</Col>
					</Row>
					{props.buildingRes.user_description && props.buildingRes.user_description != "" ?
						<Fragment>
							<Row>
								<Col md={12}>
									<h3 className="section-title section-title--not-last">About This Building</h3>
									<h3 className="section-title section-title--not-last subhead"> </h3>
									<hr/>
								</Col>
							</Row>
							<Row>
								<Col xl={6} lg={12} className="mb-3">
									{props.buildingRes.user_description && props.buildingRes.user_description != "" &&
										<p className="typography-message">
										{props.buildingRes.user_description.split('\n').map((item, key) => {
											return <React.Fragment key={key}>{item}<br/></React.Fragment>
										})}
										</p>
									}
								</Col>
								<Col xl={6} lg={12} >
									<ShowMap item={props.buildingRes} height={`360px`} />
								</Col>
							</Row>
							<ShowAmenities {...props} bldgArea={bldgArea} unitSize={unitSize} />
							<InTheArea buildingRes={buildingRes} />
						</Fragment>
					:
						<Fragment>
							<ShowAmenities {...props} bldgArea={bldgArea} unitSize={unitSize} />
							<Row>
								<Col md={12}>
									<h3 className="section-title section-title--not-last">Location</h3>
									<h3 className="section-title section-title--not-last subhead"> </h3>
									<hr/>
								</Col>
								<Col xl={12} lg={12} >
									<ShowMap item={props.buildingRes} height={`360px`} />
								</Col>
							</Row>
							<InTheArea buildingRes={buildingRes} />
						</Fragment>
					}

					<Row>
						<Col md={12}>
							<h3 className="section-title section-title--not-last"></h3>
							<h3 className="section-title section-title--not-last subhead"><p/> </h3>
						</Col>
					</Row>

					<Row className="mt-3">
						<Col md={12}>
							<h3 className="section-title section-title--not-last">Similar Bulidings</h3>
							<h3 className="section-title section-title--not-last subhead"> </h3>
						</Col>
					</Row>
					<Row>
						<RelatedBuildings {...props} />
					</Row>
				</Fragment>
			);
		}

		// Other property types (rental, commercial, office, industrial, etc.)
		const boro = _shouldShow(buildingRes.borough)
			? Array.isArray(buildingRes.borough)
				? buildingRes.borough[0].toLowerCase().trim()
				: buildingRes.borough.toLowerCase().trim()
			: "new york";
		const hood = _shouldShow(buildingRes.neighborhood)
			? Array.isArray(buildingRes.neighborhood)
				? buildingRes.neighborhood[0].toLowerCase().trim()
				: buildingRes.neighborhood.toLowerCase().trim()
			: "nyc";

		let buildingImages = _getBuildingPhotos(buildingRes);
		if (buildingImages && buildingImages.length > 0) {
			buildingImages = buildingImages.filter(image => image != "-1").map(image => ({ src: image }));
		} else {
			buildingImages = [];
		}

		return (
			<Fragment>
				<Row>
					<Col md={12} lg={12}>
						<Card>
							<CardBody className="no-border no-padding">
								<div className="product-card">
									{buildingImages.length > 0 && <ProfileGallery images={buildingImages} />}
									<div className="product-card__info">
										<Row className="product-card__top">
											{buildingRes.total_floors > 0 && _shouldShow(buildingRes.total_floors) && (
												<Col xl={2} lg={3} xs={4} className="mt-2">
													<h3>{buildingRes.total_floors}</h3>
													<span className="product-card__subtext">Floors</span>
												</Col>
											)}
											{isResidential && buildingRes.total_units > 0 && _shouldShow(buildingRes.total_units) && (
												<Col xl={2} lg={3} xs={4} className="mt-2">
													<h3>{buildingRes.total_units}</h3>
													<span className="product-card__subtext">Units</span>
												</Col>
											)}
											{buildingRes.year_built > 0 && _shouldShow(buildingRes.year_built) && (
												<Col xl={2} lg={3} xs={4} className="mt-2">
													<h3>{buildingRes.year_built}</h3>
													<span className="product-card__subtext">Year Built</span>
												</Col>
											)}
											{buildingRes.sq_ft > 0 && _shouldShow(buildingRes.sq_ft) && (
												<Col xl={3} lg={4} xs={6} className="mt-2">
													<h3>{_formatNumber(buildingRes.sq_ft)} SF</h3>
													<span className="product-card__subtext">Building Area</span>
												</Col>
											)}
										</Row>
										<hr/>
										<BuildingDetailsCard
											buildingDetails={buildingRes}
											hood={hood}
											boro={boro}
											buildingRes={buildingRes}
											property={{}}
										/>
										<hr/>
										<table className="product-summary__info">
											<tbody>
												<tr>
													<th>Current Owner:</th>
													<td>
														{!_hasPermission(props.user, 'ownership') ? (
															<EnterpriseGate
																overrideText={<span>Upgrade to see owner info</span>}
																upgrade={true}
																user={props.user}
																nextPlan={'complete'}
																hideIcon
															/>
														) : (
															<Fragment>
																{(() => {
																	const ownerStr = buildingRes.owner;
																	const isCorp = ownerStr && /\b(llc|l\.l\.c|corp|inc|ltd|l\.p\.|l\.l\.p|co\b|company|trust|assoc|group|partner|holding|estate|realty|mgmt|management|development|properties)/i.test(ownerStr);

																	// Person owner from building record - enable skip trace
																	if (ownerStr && ownerStr !== 'unavailableowner' && ownerStr !== '-1' && !isCorp) {
																		if (!isSkipTraceable) {
																			return <span>{_capitalizeText(ownerStr)}</span>;
																		}
																		const parsed = _getFirstAndLastFromFullName(ownerStr);
																		return (
																			<Fragment>
																				<SkipTraceUnifiedModal
																					user={props.user}
																					first_name={parsed.first_name || ''}
																					last_name={parsed.last_name || ''}
																					address_1={buildingRes.display_full_street_address || ''}
																					address_2={''}
																					city={buildingRes.city || ''}
																					county={buildingRes.county || ''}
																					state={buildingRes.state || ''}
																					zip={buildingRes.zip || ''}
																					borough_code={buildingRes.borough_code}
																					block={buildingRes.block}
																					lot={buildingRes.lot}
																					property={buildingRes}
																					triggerDisplay={_capitalizeText(ownerStr)}
																				/>
																				{' '}
																				<span className="small-text">(Get Contact & Profile)</span>
																			</Fragment>
																		);
																	}

																	// Corporate/LLC owner - show name, try HPD for a person to skip trace
																	if (ownerStr && ownerStr !== 'unavailableowner' && ownerStr !== '-1' && isCorp) {
																		const hpdRes = props.hpdRes;
																		let personOwner = null;
																		if (hpdRes && hpdRes.length > 0) {
																			const indvOwner = hpdRes.find(item => item.type === "individualowner");
																			const headOfficer = hpdRes.find(item => item.type === "headofficer");
																			personOwner = (indvOwner && indvOwner.full_name && indvOwner.full_name !== "first last")
																				? indvOwner
																				: (headOfficer && headOfficer.full_name && headOfficer.full_name !== "first last")
																					? headOfficer
																					: null;
																		}
																		if (personOwner) {
																			if (!isSkipTraceable) {
																				return (
																					<Fragment>
																						<span>{_capitalizeText(ownerStr)}</span>
																						<div className="small-text light-text">{_capitalizeText(personOwner.full_name)}</div>
																					</Fragment>
																				);
																			}
																			const parsed = _getFirstAndLastFromFullName(personOwner.full_name);
																			return (
																				<Fragment>
																					<SkipTraceUnifiedModal
																						user={props.user}
																						first_name={parsed.first_name || ''}
																						last_name={parsed.last_name || ''}
																						address_1={buildingRes.display_full_street_address || ''}
																						address_2={''}
																						city={buildingRes.city || ''}
																						county={buildingRes.county || ''}
																						state={buildingRes.state || ''}
																						zip={buildingRes.zip || ''}
																						borough_code={buildingRes.borough_code}
																						block={buildingRes.block}
																						lot={buildingRes.lot}
																						property={buildingRes}
																						triggerDisplay={_capitalizeText(ownerStr)}
																					/>
																					{' '}
																					<SkipTraceUnifiedModal
																						user={props.user}
																						first_name={parsed.first_name || ''}
																						last_name={parsed.last_name || ''}
																						address_1={buildingRes.display_full_street_address || ''}
																						address_2={''}
																						city={buildingRes.city || ''}
																						county={buildingRes.county || ''}
																						state={buildingRes.state || ''}
																						zip={buildingRes.zip || ''}
																						borough_code={buildingRes.borough_code}
																						block={buildingRes.block}
																						lot={buildingRes.lot}
																						property={buildingRes}
																						triggerDisplay={_capitalizeText(personOwner.full_name)}
																					/>
																					{' '}
																					<span className="small-text">(Get Contact & Profile)</span>
																				</Fragment>
																			);
																		}
																		return <span>{_capitalizeText(ownerStr)}</span>;
																	}

																	// No valid owner — fall back to HPD individual owner or head officer
																	const hpdFallback = props.hpdRes;
																	if (hpdFallback && hpdFallback.length > 0) {
																		const hpdIndv = hpdFallback.find(item => item.type === "individualowner");
																		const hpdHead = hpdFallback.find(item => item.type === "headofficer");
																		const hpdCorpOwner = hpdFallback.find(item => item.type === "corporateowner");
																		const hpdPerson = (hpdIndv && hpdIndv.full_name && hpdIndv.full_name !== "first last")
																			? hpdIndv
																			: (hpdHead && hpdHead.full_name && hpdHead.full_name !== "first last")
																				? hpdHead
																				: null;
																		if (hpdPerson || hpdCorpOwner) {
																			const corpName = hpdCorpOwner && hpdCorpOwner.corporation_name ? hpdCorpOwner.corporation_name : null;
																			if (hpdPerson) {
																				if (!isSkipTraceable) {
																					return (
																						<Fragment>
																							<span>{_capitalizeText(hpdPerson.full_name)}</span>
																							{hpdPerson.type === 'headofficer' && <span className="small-text light-text"> (Head Officer)</span>}
																							{corpName && <div className="small-text light-text" style={{color:'#858AA1'}}>{_capitalizeText(corpName)}</div>}
																							<div className="small-text light-text" style={{color:'#AAA', fontStyle:'italic'}}>Source: HPD Registration</div>
																						</Fragment>
																					);
																				}
																				const parsed = _getFirstAndLastFromFullName(hpdPerson.full_name);
																				return (
																					<Fragment>
																						<SkipTraceUnifiedModal
																							user={props.user}
																							first_name={parsed.first_name || ''}
																							last_name={parsed.last_name || ''}
																							address_1={buildingRes.display_full_street_address || ''}
																							address_2={''}
																							city={buildingRes.city || ''}
																							county={buildingRes.county || ''}
																							state={buildingRes.state || ''}
																							zip={buildingRes.zip || ''}
																							borough_code={buildingRes.borough_code}
																							block={buildingRes.block}
																							lot={buildingRes.lot}
																							property={buildingRes}
																							triggerDisplay={_capitalizeText(hpdPerson.full_name)}
																						/>
																						{hpdPerson.type === 'headofficer' && <span className="small-text light-text"> (Head Officer)</span>}
																						{corpName && <div className="small-text light-text" style={{color:'#858AA1'}}>{_capitalizeText(corpName)}</div>}
																						{' '}
																						<span className="small-text">(Get Contact & Profile)</span>
																						<div className="small-text light-text" style={{color:'#AAA', fontStyle:'italic'}}>Source: HPD Registration</div>
																					</Fragment>
																				);
																			}
																			if (corpName) {
																				return (
																					<Fragment>
																						<span>{_capitalizeText(corpName)}</span>
																						<div className="small-text light-text" style={{color:'#AAA', fontStyle:'italic'}}>Source: HPD Registration</div>
																					</Fragment>
																				);
																			}
																		}
																	}

																	return <span>Unavailable</span>;
																})()}
															</Fragment>
														)}
													</td>
												</tr>
											</tbody>
										</table>
									</div>
								</div>
							</CardBody>
						</Card>
					</Col>
				</Row>

				{(isRental || ownershipType.indexOf('multi') >= 0) &&
					<BuildingManagement {...props} />
				}

				{props.buildingRes.user_description && props.buildingRes.user_description != "" &&
					<Fragment>
						<Row>
							<Col md={12}>
								<h3 className="section-title section-title--not-last">About This Property</h3>
								<h3 className="section-title section-title--not-last subhead"> </h3>
								<hr/>
							</Col>
						</Row>
						<Row className="mb-3">
							<Col xl={12} lg={12}>
								<p className="typography-message">
								{props.buildingRes.user_description.split('\n').map((item, key) => {
									return <React.Fragment key={key}>{item}<br/></React.Fragment>
								})}
								</p>
							</Col>
						</Row>
					</Fragment>
				}
				{isResidential &&
				<ShowAmenities {...props} bldgArea={bldgArea} unitSize={unitSize} />
				}
				<Row>
					<Col md={12}>
						<h3 className="section-title section-title--not-last">Location</h3>
						<h3 className="section-title section-title--not-last subhead"> </h3>
						<hr/>
					</Col>
					<Col xl={12} lg={12}>
						<ShowMap item={props.buildingRes} height={`360px`} />
					</Col>
				</Row>
				{isResidential &&
					<InTheArea buildingRes={buildingRes} />
				}
				<Row className="mt-3">
					<Col md={12}>
						<h3 className="section-title section-title--not-last">Similar Bulidings</h3>
						<h3 className="section-title section-title--not-last subhead"> </h3>
					</Col>
				</Row>
				<Row>
					<RelatedBuildings {...props} />
				</Row>
			</Fragment>
		);
	};

	return (
			  <Container className="mobile-no-padding">
			  {(true || buildingRes.building_status == "resale") &&
			  <div className="tabs">
			  <div className="tabs__wrap mb-2">
				  <Nav tabs>

					 <NavItem>
					  <NavLink
						className={classnames({ active: activeTab === 'summary' })}
						onClick={() => {
						  _toggleTab('summary');
						}}
					  >
						<span className="tab-title">Summary</span>
					  </NavLink>
					</NavItem>
					<NavItem>
					  <NavLink
						className={classnames({ active: activeTab === 'details' })}
						onClick={() => {
						  _toggleTab('details');
						}}
					  >
						<span className="tab-title">Details</span>
					  </NavLink>
					</NavItem>

				  </Nav>
				</div>
			  </div>
		  		}

				{activeTab === 'summary' &&
				  <TabPane tabId="summary">
					{renderSummaryContent()}
				  </TabPane>}
				  {activeTab === 'details' &&
					<TabPane tabId="details">
						<Row className="mb-3">
							<Col md={12} xs={12} lg={12} xl={12}>
								{streetView ? (
									<GStreetMap
										{...props}
										center={{
											lat: buildingRes.geocode &&
												_parseCoordinates(buildingRes.geocode)[1],
											lng: buildingRes.geocode &&
												_parseCoordinates(buildingRes.geocode)[0],
										}}
									/>
								) : (
									<SalesMapBox
										{...props}
										mapContainerWidth={1000}
										fullSize={true}
										freez
										initialZoom={15}
										standardView={standardView}
										buildingClicked={_selectedBuildingClick}
										handleBuildingClick={handleBuildingClick}
									/>
								)}
								<MapModal
									{...props}
									toggleView={toggleView}
									handleStreetView={_handleStreetView}
									standardView={standardView}
									streetView={streetView}
									section
									showMapViewButton
									showStreetView
								/>
							</Col>
						</Row>
						<BuildingProfile
							buildingDetails={props.buildingRes}
							{...props}
						  />
					</TabPane>
				  }
			  </Container>
		)
};

export default connect(state => ({
  user: state.user,
}))(Profile);
